import { Component, OnInit } from '@angular/core';
import MarketWatchListItem, {
  MarketWatchService,
} from '../../services/market-watch-service';

@Component({
  selector: 'pla-landing-market-watch',
  templateUrl: './landing-market-watch.component.html',
  styleUrls: ['./landing-market-watch.component.scss'],
})
export class LandingMarketWatchComponent implements OnInit {
  public topThisYear: MarketWatchListItem[] = [];

  constructor(private marketWatchService: MarketWatchService) {}

  ngOnInit(): void {
    this.FetchMarketWatchData();
  }

  private FetchMarketWatchData(): void {
    this.marketWatchService.GetTopSoldThiYear((res: MarketWatchListItem[]) => {
      if (res === null) {
        return;
      }

      this.topThisYear = res;
    });
  }

  public SellerNameMapper(
    sellerName: string,
    removeAuctionCode: boolean = false
  ): string {
    if (sellerName.startsWith('DVLA AUCTION')) {
      if (removeAuctionCode) return 'DVLA Auction';
      else return sellerName.replace('DVLA AUCTION', 'DVLA Auction');
    }

    if (sellerName.startsWith('CC')) {
      return 'Collecting Cars';
    }

    return sellerName;
  }
}
